export var WalletStrategyEmitterEventType;
(function (WalletStrategyEmitterEventType) {
    WalletStrategyEmitterEventType["TransactionFail"] = "transaction-fail";
    WalletStrategyEmitterEventType["TransactionSigned"] = "transaction-signed";
    WalletStrategyEmitterEventType["TransactionSignStart"] = "transaction-sign-start";
    WalletStrategyEmitterEventType["TransactionBroadcastEnd"] = "transaction-broadcast-end";
    WalletStrategyEmitterEventType["WalletStrategyDisconnect"] = "wallet-strategy-disconnect";
    WalletStrategyEmitterEventType["TransactionBroadcastStart"] = "transaction-broadcast-start";
    WalletStrategyEmitterEventType["TransactionPreparationEnd"] = "transaction-preparation-end";
    WalletStrategyEmitterEventType["TransactionPreparationStart"] = "transaction-preparation-start";
})(WalletStrategyEmitterEventType || (WalletStrategyEmitterEventType = {}));
